import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.reduce.js";
import { createSelector } from "reselect";
export var contactsSelector = function contactsSelector(state) {
  return state.contact.contacts;
};
export var contactChatIdsInListSelector = function contactChatIdsInListSelector(state) {
  return state.contact.contactChatIdsInList;
};
export var currentContactChatIdSelector = function currentContactChatIdSelector(state) {
  return state.contact.currentContactChatId;
};
export var sortedContactsSelector = createSelector(contactsSelector, function (contacts) {
  return Object.values(contacts).sort(function (a, b) {
    return b.lastUpdated.getTime() - a.lastUpdated.getTime();
  });
});
export var contactsInListSelector = createSelector(sortedContactsSelector, contactChatIdsInListSelector, function (contacts, chatIdsInList) {
  return contacts.filter(function (c) {
    return chatIdsInList.includes(c.chatId.encode());
  });
});
export var currentContactSelector = createSelector(currentContactChatIdSelector, contactsInListSelector, function (currentContactChatId, contactsInList) {
  return contactsInList.filter(function (c) {
    return c.chatId.encode() === currentContactChatId;
  })[0];
});
export var totalUnreadMessageCountSelector = createSelector(sortedContactsSelector, function (contacts) {
  return contacts.reduce(function (acc, c) {
    return acc + c.unreadMessageCount;
  }, 0);
});